import { writable, derived } from "svelte/store";
import getColors from '../strapi/getColors.js';

const store = writable([], () => {
  setColors();
  return () => {};
})

async function setColors() {
  let colors = await getColors();
  if(colors) {
    store.set(colors);
  }
}

// Derives tore for better and faster search
export const colorsToSearch = derived( store, $colors => {
  let preparedColors = $colors;

  preparedColors.forEach(color => {
    let combined = color.producer + ' '
        + color.line + ' '
        + color.colorFamily + ' '
        + color.name + ' '
        + color.tags + ' '
        + color.pigments

    color.content = combined;
  })

  return preparedColors;
})


// Get all Producers
export const producers = derived (store, $colors => {

  let prods = ['All'];

  $colors.forEach (color => {
    if( !prods.includes (color.producer)){
      prods = [...prods, color.producer]
    }
  })

  return prods.sort();
})

// Get all Medium
export const mediums = derived (store, $colors => {

  let meds = ['All'];

  $colors.forEach (color => {
    if( !meds.includes (color.medium)){
      meds = [...meds, color.medium]
    }
  })

  return meds;
})

// Get all stainings
export const stainings = derived (store, $colors => {

  let stainings = ['All'];

  $colors.forEach (color => {
    if( !stainings.includes (color.staining) && color.staining !== 'unknown'){
      stainings = [...stainings, color.staining]
    }
  })

  return stainings;
})

// Get all granulatings
export const granulatings = derived (store, $colors => {

  let granulatings = ['All'];

  $colors.forEach (color => {
    if( !granulatings.includes (color.granulation) && color.granulation !== 'unknown'){
      granulatings = [...granulatings, color.granulation]
    }
  })

  return granulatings;
})


// Get all Transparency
export const transparencies = derived (store, $colors => {

  let transparencies = ['All'];

  $colors.forEach (color => {
    if( !transparencies.includes (color.transparency) && color.transparency !== 'unknown'){
      transparencies = [...transparencies, color.transparency]
    }
  })

  return transparencies;
})

// Get all qualities
export const qualities = derived (store, $colors => {

  let qualities = ['All'];

  $colors.forEach (color => {
    if( !qualities.includes (color.quality) && color.quality !== 'unkown'){
      qualities = [...qualities, color.quality]
    }
  })

  return qualities;
})




export default store;
